import { classes, style } from 'typestyle'
import { SignedImage } from '../../default/snippets/attachment'
import { p8 } from '../../styles/styleset/padding/p8'
import { textCenter } from '../../styles/styleset/text-center/textCenter'
import { Box } from '../box/box.component'
import { Text } from '../text/text.component'
import { useTheme } from '../theme'

export const UploadFieldView = (props: { value?: [] }) => {
  const { value = [] } = props
  const [theme] = useTheme()

  return (
    <Box
      flex
      baseline="none"
      className={style({
        flexWrap: 'wrap',
      })}
    >
      {value.length === 0 ? (
        <Text size="md">-</Text>
      ) : (
        <>
          {value.map((item: any, key) => {
            const { file } = item

            return (
              <Box
                className={classes(
                  style({
                    margin: 2,
                    border: '1px solid transparent',
                    cursor: 'pointer',
                    $nest: {
                      '&:hover': {
                        borderColor: theme.getBaseline('primary').color.medium,
                      },
                    },
                  }),
                )}
                maxWidth={120}
                maxHeight={120}
                minWidth={120}
                minHeight={120}
                key={key}
                alignCenterX
                alignCenterY
                rounded
                onClick={() => {
                  window.open(file.body.location)
                }}
              >
                {file?.body?.mimetype?.includes?.('image') ? (
                  <SignedImage id={file?.id} key={key} access="public" file={item} />
                ) : (
                  <Box row className={classes(p8, textCenter)}>
                    <Text>No Preview</Text>
                    <Text size="xs" baseline="surface" lighter>
                      {file?.body?.fileName}
                    </Text>
                  </Box>
                )}
              </Box>
              // <Text link semiBold key={key}>
              //   <a href={file?.location} target="_blank" rel="noreferrer">
              //     {file?.fileName || file?.name || file?.name}
              //   </a>
              // </Text>
            )
          })}
        </>
      )}
    </Box>
  )
}
